import React from 'react';
import { makeStyles } from '@mui/styles';

import LinearProgress from '@mui/material/LinearProgress';

import colorVariables from '../../styles/variables';

const useStyles = makeStyles(() => ({
  colorPrimary: {
    backgroundColor: colorVariables.transmitPurple,
  },
  barColorPrimary: {
    backgroundColor: colorVariables.transmitPurpleLightHover,
  },
}));

const LoadingProgress = () => {
  const classes = useStyles();

  return <LinearProgress classes={{ colorPrimary: classes.colorPrimary, barColorPrimary: classes.barColorPrimary }} />;
};

export default LoadingProgress;
